import { QcBizInquiryForConvInfoSchema } from "./InquiryObjects";
import { QcBizGuestForConvInfoSchema } from "./QcBizGuestForConvInfo";
import { QcUserSchema } from "./QcUser";
import { z } from "zod";

export type QcBizConversationInfoForQcConversation = z.infer<typeof QcBizConversationInfoForQcConversationSchema>;
export const QcBizConversationInfoForQcConversationSchema = z.object({
  assign_staff_id_account: z.number().nullable(),
  close_chat_state: z.string(),
  conversation_id: z.string(),
  created_at: z.string(),
  forward_respond_staff_id_account: z.number().nullable(),
  forward_target_name: z.string(),
  guest: QcBizGuestForConvInfoSchema,
  guest_id: z.number(),
  inquiry: QcBizInquiryForConvInfoSchema,
  inquiry_id: z.number(),
  inquiry_trigger: z.string().nullable(),
  is_sms_chat: z.boolean(),
  responder_id: z.number(),
  responder_name: z.string().nullable(),
  staff_conversation_id: z.string(),
  staff_qc_user: QcUserSchema,
  state: z.string(),
  updated_at: z.string(),
});
